<template>
  <!-- 指定给会员的商品 -->
  <div v-if="isVipGoods">
    <!-- 没有开通会员 -->
    <div v-if="!isFreeVipBuy">
      <div class="goods-specs-vip" @click="buyVip">
        <img src="@/assets/images/goods/specs_vip_icon.png" class="icon" />
        <p class="text">成为金标尺会员，此{{ goodsTypeText }}</p>
        <img src="@/assets/images/goods/specs_vip_arrow_icon.png" class="arrow-icon" />
      </div>
    </div>
  </div>

  <!-- 非会员商品 -->
  <div class="goods-specs" v-else>
    <div class="goods-specs-item">
      <div class="name">价格</div>
      <!--线下商品价格显示-->
      <div class="content price" v-if="offlineProduct && offlineProduct.case_type == 'group'">
        <p class="price-text price-text_new">
          <span class="symbol">￥</span>
          <span class="number">{{ titleObj.starPrice }}</span>
          <span
            class="number"
            style="margin: 0 0.1rem"
            v-if="titleObj.starPrice < titleObj.endPrice"
          >
            -
          </span>
          <span class="number" v-if="titleObj.starPrice < titleObj.endPrice">
            {{ titleObj.endPrice }}
          </span>
        </p>
      </div>

      <!--线上商品价格显示-->
      <div class="content price" v-else>
        <!--普通商品-->
        <template v-if="goodsData.usability == 'product'">
          <!-- 有会员价格 -->
          <div v-if="isHasVipPrice">
            <!-- 有会员价资格 -->
            <div v-if="isVipPricePower" style="display: flex; align-items: center">
              <p class="price-text price-text_new">
                <span class="symbol">会员价￥</span>
                <span class="number">{{ vipPrice }}</span>
              </p>
              <p class="price-text price-text_old" style="margin-left: 0.2rem">
                <span class="symbol">￥</span>
                <span class="number">{{ newPrice }}</span>
              </p>
            </div>
            <!-- 没有会员资格 -->
            <div v-else style="display: flex; align-items: center">
              <p class="price-text price-text_new">
                <span class="symbol">￥</span>
                <span class="number">{{ newPrice }}</span>
              </p>
              <p class="price-text price-text_vip">
                <span class="symbol">会员价￥</span>
                <span class="number">{{ vipPrice }}</span>
              </p>
            </div>
          </div>
          <!-- 没有会员价格 -->
          <div v-else style="display: flex; align-items: center">
            <p class="price-text price-text_new">
              <span class="symbol">￥</span>
              <span class="number">{{ newPrice }}</span>
            </p>
            <p class="price-text price-text_old" v-if="isShowOldPrice">
              <span class="symbol">￥</span>
              <span>{{ oldPrice }}</span>
            </p>
          </div>
        </template>

        <!--身份下的课程-->
        <template v-if="goodsData.usability == 'identity'">
          <p class="price-text price-text_new">
            <span class="number">真题功能包</span>
          </p>
        </template>

        <!--当前商品是功能包-->
        <template v-if="unitName == 'identity'">
          <p class="price-text price-text_new">
            <span class="symbol">￥</span>
            <span class="number">{{ newPrice }}</span>
          </p>
          <p class="price-text price-text_old" v-if="isShowOldPrice">
            <span class="symbol">￥</span>
            <span>{{ oldPrice }}</span>
          </p>
        </template>

        <!--免费商品-->
        <template v-if="goodsData.usability == 'free'">
          <p class="price-text price-text_new">
            <span class="number">免费</span>
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodsInforSpecsPrice',
  props: {
    goodsData: Object,
    unitName: String,
    offlineProduct: Object,
    titleObj: Object,
    currentSpecs: Object,
    productCase: Object,
  },
  computed: {
    // 指定给会员的商品
    isVipGoods() {
      return this.goodsData?.usability === 'membership'
    },
    // 免费会员购买
    isFreeVipBuy() {
      return this.isVipGoods && !!this.goodsData.is_buy_membership
    },
    // 是否可以使用会员价购买
    isVipPricePower() {
      return this.goodsData.is_membership_price
    },
    // 是否有会员价格
    isHasVipPrice() {
      let price = this.currentSpecs?.amount_membership || this.goodsData.product.membership_price
      return !!price && price !== '0.00'
    },
    // 免费商品
    isFreeGoods() {
      return this.goodsData?.usability === 'free'
    },
    newPrice() {
      let price = this.currentSpecs?.amount || this.goodsData.product.price
      return this.$util.clearPriceZero(price)
    },
    oldPrice() {
      let price = this.currentSpecs?.amount_original || this.goodsData.product.o_price
      return this.$util.clearPriceZero(price)
    },
    isShowOldPrice() {
      let price = this.currentSpecs?.amount || this.productCase.price,
        old_price = this.currentSpecs?.amount_original || this.productCase.o_price
      return price !== old_price && old_price != '0.00' && old_price != '0'
    },
    //商品类型文本
    goodsTypeText() {
      let text = '课程免费学'
      if (this.unitName === 'question') {
        text = '题集免费练习'
      }
      if (this.unitName === 'identity') {
        text = '功能包免费学'
      }
      return text
    },
  },

  data() {
    return {}
  },
  methods: {
    buyVip() {
      this.$emit('clickBuyVip')
    },
  },
}
</script>

<style scoped lang="scss">
.goods {
  &-specs {
    &-item {
      display: flex;
      padding: 0.2rem 0;

      .name {
        width: 1.92rem;
        font-size: 0.4rem;
        color: #919499;
        line-height: 0.4rem;
      }

      .content {
        position: relative;
        display: flex;
        align-items: flex-end;
        flex: 1;
        font-size: 0;

        span {
          font-size: 0.4rem;
          line-height: 0.4rem;
        }

        .icon {
          position: absolute;
          width: 0.5rem;
          top: 0;
          right: 0;
        }
      }

      .price {
        &-text {
          .symbol {
            font-size: 0.35rem;
          }

          .number {
            font-size: 0.42rem;
            // font-family: 'DIN-Bold';
            font-weight: bold;
          }

          &_new {
            color: #ff6a4d;
          }

          &_old {
            color: #919499;
            text-decoration: line-through;
          }

          &_vip {
            font-size: 0.35rem;
            color: #e5b66e;
            margin-left: 0.2rem;

            .number {
              font-size: 0.35rem;
            }
          }
        }
      }
    }
  }
}
</style>
